import React, { Component } from 'react';
import '../css/Personalizados.css';
import naviero from '../img/reporte.png';
import '../js/EventoPersonalizados.js';
class Personalizados extends Component {
  render() {
    return (
      <div className="contenedorPersonalizado">
        <h2 className="tituloPersonalizados">Productos</h2>
        <hr className="barritaPersonalizado"></hr>
        <div className="panelPersonalizado">
          <div class="panel panel-primary" id="panel-personalizado" >
            <a id="naviero" href="#popup"><div class="panel-heading" id='panel-naviero'>
            </div></a>
            <div className="panelContenedor1" class="panel-body">
              <p className="texttoGeneral">SIIA Administrativo Contable</p>
              <a id="naviero-personalizados" className="btn btn-primary" href="#popup">
                <p className="parrafoContenedor">Consultar el Producto</p></a>
            </div>
          </div>
          <div class="panel panel-primary" id="panelTurismo-contenedor">
            <a id="turismo" href="#popup"><div class="panel-heading" id='panel-turismo'>

            </div></a>
            <div class="panel-body" id="sistemaTurismo">
              <p className="texttoGeneral"> SIIA Facturación Electrónica</p>
              <a id="turismo-personalizados" className="btn btn-primary" href="#popup">
                <p className="parrafo-consultar1">Consultar el Producto</p></a>
            </div>
          </div>
          <div class="panel panel-primary" id="panelPrimary1">
            <a id="tienda" href="#popup"><div class="panel-heading" id='panel-tienda'>

            </div></a>
            <div class="panel-body" id="contenedorCuerpo1">
              <p className="texttoGeneral">SIIA Sistema de Gestión Tienda</p>
              <a id="tienda-personalizados" className="btn btn-primary" href="#popup">
                <p className="parrafo-consultar2">Consultar el Producto</p></a>
            </div>
          </div>
        </div>
        <div class="panel panel-primary" id="panelPrimarymultiempresas">
          <a id="tienda" href="#popup"><div class="panel-heading" id='panel-multiempresa'>

          </div></a>
          <div class="panel-body" id="contenedorCuerpo1">
            <p className="texttoGeneral">SIIA Contable Multiempresas</p>
            <a id="tienda-personalizados" className="btn btn-primary" href="#popup">
              <p className="parrafo-consultar2">Consultar el Producto</p></a>
          </div>
        </div>
        <h2 className="tituloPersonalizados">Productos Personalizados</h2>
        <hr className="barritaPersonalizado"></hr>
        <div className="campoPersonalizado">
          <div class="panel panel-primary" id="campoPanel1">
            <a id="textil" href="#popup"><div class="panel-heading" id='panel-textil' href="#popup">

            </div></a>
            <div class="panel-body" id="sistemaTextil">
              <p className="texttoGeneral">SIIA Produccion</p>
              <a id="textil-personalizados" className="btn btn-primary" href="#popup">
                <p className="consultarTextil">Consultar el Producto</p></a>
            </div>
          </div>
          <div class="panel panel-primary" id="sistemaTransporte">
            <a id="transporte" href="#popup"><div class="panel-heading" id='panel-transporte'>

            </div></a>
            <div class="panel-body" id="transporte-panel">
              <p className="texttoGeneral">SIIA Turismo Receptivo</p>
              <a id="transporte-personalizados" className="btn btn-primary" href="#popup">
                <p className="consultarTransporte">Consultar el Producto</p></a>
            </div>
          </div>
          <div class="panel panel-primary" id="sistemaAduana">
            <a id="aduana" href="#popup"><div class="panel-heading" id='panel-aduana'>

            </div></a>
            <div class="panel-body" id="panelAgenciaAduana" >
              <p className="texttoGeneral">SIIA Agencia de Carga</p>
              <a id="aduana-personalizados" className="btn btn-primary" href="#popup">
                <p className="consultarAduana">Consultar el Producto</p></a>
            </div>
          </div>
        </div>
        <div class="modal-wrapper" id="popup">
          <div class="popup-contenedor">
            <h2 id="titulo-personalizado"></h2>
            <p id="texto-personalizado"></p>
            <img id="imagen-personalizado" src={naviero}></img>
            <a class="popup-cerrar" href="#panel-naviero" >X</a>
          </div>
        </div>

      </div>


    );


  }



}
export default Personalizados;



// WEBPACK FOOTER //
// ./src/components/Personalizados.jsx